import { render, staticRenderFns } from "./FileSectionHeader.vue?vue&type=template&id=562498e4&scoped=true&"
import script from "./FileSectionHeader.vue?vue&type=script&lang=js&"
export * from "./FileSectionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562498e4",
  null
  
)

export default component.exports